import * as React from "react";
import {IApplicationGuard, TypeDefs, lazyInject} from "@athena-portal/core";

export class RegisterPage extends React.Component {
    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    public async componentDidMount() {
        const url = new URL(window.location.href);
        const redirectUri = url.searchParams.get("redirect_uri");
        if (redirectUri) {
            this.applicationGuard.getRegisterUrl(redirectUri).subscribe(
                (registerUrl: string) => {
                    window.location.replace(registerUrl);
                }
            )
        }
    }

    public render() {
        return null;
    }
}
